import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {AuthRedirectParents, PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import '../../../static/css/pages/news/news.css';
import {Link} from "react-router-dom";
import {ThinArrowLeft} from "../../../components/icons/material-icons";

interface newsInterface {
    nd: string,
    title: string,
    body: string,
    img: string,
    category: string,
    createdAt: string,
    hasSignup: 0 | 1,
}

export const StudentsNewsScreen = () => {
    const [list, setList] = useState<newsInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/parents/news/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: newsInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "اطلاعیه‌ها | نهال";
        fetchList();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'اطلاعیه‌ها', url: '/students/news'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        {
                            list.length < 1 ?
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>اطلاعیه‌های آموزشگاه</b>
                                    </div>
                                    <div className="staff--not-found">
                                        <em style={{backgroundImage: 'url(/svg/news.svg)'}}/>
                                        <b>اطلاعیه‌ای یافت نشد</b>
                                        <p>در حال حاضر، اطلاعیه‌ای برای نمایش موجود نیست.</p>
                                    </div>
                                </div>
                                :
                                <>
                                    <div className="row" style={{paddingBottom:20}}>
                                        {
                                            list.map((n, i) =>
                                                <div className="col-lg-4" key={"JJ29fu3iDDDjvu3"+i}>
                                                    <Link to={`/students/news/view/${n.nd}`}
                                                          className="news-item">
                                                        <i style={{backgroundImage:`url(${ServerImage(n.img,400)})`}}/>
                                                        <div>
                                                            <em>{n.category}</em>
                                                            <b>{n.title}</b>
                                                            <p className="max-lines-2">{n.body}</p>
                                                            <div>
                                                                <button>
                                                                    <span>مشاهده</span>
                                                                    <ThinArrowLeft/>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            )
                                        }
                                    </div>
                                </>
                        }
                    </div> : null
            }
        </>
    );
};